<template>
  <div v-if="isEditing">
    <template v-for="(group, groupIndex) in value">
      <div :key="groupIndex">
        <div class="filter-group">
          <div class="filter-group-header">
            <span>group {{ groupIndex + 1 }}</span>
            <Button @click="removeFilterGroup(groupIndex)">
              <MdIcon name="close" />
            </Button>
          </div>

          <div v-for="(filter, filterIndex) in group.filters" :key="filterIndex" class="filter-wrapper">
            <pipeline-filter :value="group.filters[filterIndex]" @input="updateFilter(groupIndex, filterIndex, $event)" />
            <Button @click="removeFilter(groupIndex, filterIndex)">
              <MdIcon name="close" />
            </Button>
          </div>
          <div>
            <Button @click="addFilter(groupIndex)">
              <MdIcon name="plus" />
              Filter
            </Button>
          </div>
        </div>
        <div v-if="groupIndex !== value.length - 1" class="separator">
          OR
        </div>
      </div>
    </template>
    <Button @click="addFilterGroup">Add Filter Group</Button>
  </div>
  <div v-else>
    <template v-for="(group, groupIndex) in value">
      <div :key="groupIndex">
        <div class="filter-group">
          <div class="filter-group-header">
            <span>group {{ groupIndex + 1 }}</span>
          </div>

          <div v-for="(filter, filterIndex) in group.filters" :key="filterIndex" class="filter-wrapper">
            {{ filter.database }}.{{ filter.field }} {{ filter.operator }} {{ filter.value }}
          </div>
        </div>
        <div v-if="groupIndex !== value.length - 1" class="separator">
          OR
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Button from '@/components/common/Button.vue';
import MdIcon from '@/components/common/MdIcon.vue';
import Filter from './Filter.vue';
export default {
  name: 'Filters',
  components: {
    Button,
    MdIcon,
    'pipeline-filter': Filter
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    isEditing: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    addFilterGroup() {
      this.$emit('input', [...this.value, { filters: [] }]);
    },
    removeFilterGroup(index) {
      const newValue = [...this.value];
      newValue.splice(index, 1);
      this.$emit('input', newValue);
    },
    addFilter(groupIndex) {
      const newValue = this.value.map((group, index) => {
        if (index !== groupIndex) {
          return group;
        }
        return { ...group, filters: [...group.filters, { field: null, operator: null, value: null, database: null }] };
      });
      this.$emit('input', newValue);
    },
    removeFilter(groupIndex, filterIndex) {
      const newValue = this.value.map((group, index) => {
        if (index !== groupIndex) {
          return group;
        }
        return { ...group, filters: group.filters.filter((filter, index) => index !== filterIndex) };
      });
      this.$emit('input', newValue);
    },
    updateFilter(groupIndex, filterIndex, newFilter) {
      const newValue = this.value.map((group, index) => {
        if (index !== groupIndex) {
          return group;
        }
        return {
          ...group,
          filters: group.filters.map((filter, index) => (index === filterIndex ? { ...filter, ...newFilter } : filter))
        };
      });
      this.$emit('input', newValue);
    }
  }
};
</script>
<style lang="scss" scoped>
.filter-group {
  border: 1px solid var(--theme-highlight);
  padding: 10px;
  margin-bottom: 20px;

  .filter-group-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    span {
      font-weight: bold;
    }
  }
  .filter-wrapper {
    display: grid;
    grid-template-columns: 1fr max-content;
    gap: 10px;
    align-items: center;
    margin-bottom: 10px;
  }
}

.separator {
  text-align: center;
  margin: 10px 0;
  font-style: italic;
}
</style>
